import lodashGet from 'lodash.get'
import lodashIsEmpty from 'lodash.isempty'
import { uuid } from 'vue-uuid'
import { FormReposition } from '@/helpers/storeHelper'

export default {
  updateFormItem(
    { commit, dispatch, getters },
    { id = null, formItemId = '', path = null, value = null, stack = 'undo', stackToClear = 'redo' } = {}
  ) {
    if (!id || !formItemId) {
      return
    }

    const form = getters.objectById(id)
    const oldValue = lodashGet(
      form.options.items.find(i => i.id === formItemId),
      `options${path && `.${path}`}`
    )

    commit('updateFormItem', { id, formItemId, path, value })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/updateFormItem',
        params: { id, formItemId, path, value: oldValue },
        stackToClear,
      },
      { root: true }
    )
  },

  updateFormItemPosition(
    { state, commit, dispatch, getters },
    { id = null, formItemId = '', from = null, to = null, stack = 'undo', stackToClear = 'redo' } = {}
  ) {
    if (!id || !formItemId || from === null || to === null) {
      return
    }

    const movingDown = to > from

    const form = getters.objectById(id)
    const siblings = form.options.items.filter(i => i.id !== formItemId)

    const siblingsPositioned = siblings
      .filter(sibling => {
        const position = sibling.options.position[state.currentView]
        return movingDown ? position > from && position <= to : position < from && position >= to
      })
      .map(sibling => ({
        id: sibling.id,
        position: sibling.options.position[state.currentView] + (movingDown ? -1 : +1),
      }))

    commit('updateFormItemPosition', { id, toMove: [{ id: formItemId, position: to }, ...siblingsPositioned] })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/updateFormItemPosition',
        params: { id, formItemId, from: to, to: from },
        stackToClear,
      },
      { root: true }
    )
  },

  addFormItem(
    { commit, dispatch, getters },
    { id = null, formItemId = '', type = '', options = {}, stack = 'undo', stackToClear = 'redo' } = {}
  ) {
    if (!formItemId) {
      formItemId = `W-${uuid.v1()}`
    }

    const form = getters.objectById(id)
    const formItem = newFormItem(type, form.options.items.length, options)

    const siblings = form.options.items.filter(i => i.id !== formItemId)

    const reposition = FormReposition(siblings, formItem.options.position, (crr, ref) => crr >= ref, 1)

    commit('addFormItem', { id, formItem: { id: formItemId, ...formItem }, reposition })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/removeFormItem',
        params: { id, formItemId },
        stackToClear,
      },
      { root: true }
    )
  },

  removeFormItem(
    { commit, dispatch, getters },
    { id = null, formItemId = '', stack = 'undo', stackToClear = 'redo' } = {}
  ) {
    const form = getters.objectById(id)
    const formItem = form.options.items.find(i => i.id === formItemId)

    const siblings = form.options.items.filter(i => i.id !== formItemId)

    const reposition = FormReposition(siblings, formItem.options.position, (crr, ref) => crr > ref, -1)

    commit('removeFormItem', { id, formItemId, reposition })

    dispatch(
      'history/pushToStack',
      {
        stack,
        action: 'landing/addFormItem',
        params: { id, formItemId, type: formItem.type, options: formItem.options },
        stackToClear,
      },
      { root: true }
    )
  },
}

function newFormItem(type, position, options) {
  switch (type) {
    case 'Text':
      return newTextFormItem(options, position)
    case 'Email':
      return newEmailFormItem(options, position)
    case 'Phone':
      return newPhoneFormItem(options, position)
    case 'Button':
      return newButtonFormItem(options, position)
    default:
      return null
  }
}

function newTextFormItem(options, position) {
  const text = {
    title: 'Text',
    type: 'Text',
    options: {
      label: 'Text',
      placeholder: 'text',
      id: 'text',
      required: false,
      name: 'text',
      position: {
        sm: position,
        md: position,
        lg: position,
      },
      size: {
        sm: 12,
        md: 12,
        lg: 12,
      },
    },
  }

  if (!lodashIsEmpty(options)) {
    text.options = options
  }
  return text
}

function newEmailFormItem(options, position) {
  const text = {
    title: 'Email',
    type: 'Email',
    options: {
      label: 'Email',
      placeholder: 'example@example.com',
      id: 'email',
      required: false,
      name: 'email',
      position: {
        sm: position,
        md: position,
        lg: position,
      },
      size: {
        sm: 12,
        md: 12,
        lg: 12,
      },
    },
  }

  if (!lodashIsEmpty(options)) {
    text.options = options
  }
  return text
}

function newPhoneFormItem(options, position) {
  const text = {
    title: 'Phone',
    type: 'Phone',
    options: {
      label: 'Telefone',
      placeholder: '(00) 0000-0000',
      id: 'phone',
      required: false,
      name: 'phone',
      position: {
        sm: position,
        md: position,
        lg: position,
      },
      size: {
        sm: 12,
        md: 12,
        lg: 12,
      },
    },
  }

  if (!lodashIsEmpty(options)) {
    text.options = options
  }
  return text
}

function newButtonFormItem(options, position) {
  const button = {
    title: 'Submit',
    type: 'Button',
    options: {
      text: 'Submit',
      position: {
        sm: position,
        md: position,
        lg: position,
      },
      size: {
        sm: 12,
        md: 12,
        lg: 3,
      },
    },
  }

  if (!lodashIsEmpty(options)) {
    button.options = options
  }
  return button
}
